// extracted by mini-css-extract-plugin
module.exports = {"IAndCArchiveMonitor":"IAndCArchiveMonitor_IAndCArchiveMonitor__3L0Gf"};